import { TotalizarRepository } from "repository/totalizar/TotalizarRepo";
import { AxiosHttpService } from "services/AxiosHttpService";
import { createApiClient } from "utils/AxiosClient";

export class TotalizarService {
    private httpService: IHttpService;

    public totalizar: TotalizarRepository

    constructor(url?: string) {
        const baseURL = url ? url : `${process.env.REACT_APP_TK_GW_DOMAIN}/v1/virtual_interpretation`;
        const apiClient = createApiClient(baseURL)
        this.httpService = new AxiosHttpService(apiClient);

        this.totalizar = new TotalizarRepository(this.httpService);

    }

}
